module.exports = __webpack_public_path__ + "img/building-entry.748fdda3.jpg";